import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;

  &:invalid + ${Container} {
    border-color: #dc3545;
  }
`
